module.exports = __webpack_public_path__ + "static/media/ScaleKOLs.45187380.png";